import React, { Suspense } from 'react';

import { useAppointmentId } from '@eluve/frontend-appointment-hooks';
import { AppointmentPageLoader } from '@eluve/frontend-feature-appointment';

import { AppointmentLayout } from './AppointmentLayout';
import { AppointmentFileSyncProvider } from './components/AppointmentFileSyncProvider';

export const AppointmentPage: React.FC = () => {
  const appointmentId = useAppointmentId();

  return (
    <Suspense fallback={<AppointmentPageLoader />}>
      <AppointmentFileSyncProvider appointmentId={appointmentId}>
        <AppointmentLayout />
      </AppointmentFileSyncProvider>
    </Suspense>
  );
};
